module.exports = __webpack_public_path__ + "static/img/6.1358a90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/6.png
// module id = W0pJ
// module chunks = 57